import * as React from 'react';
import { connect } from 'react-redux';
import './ReplacementValue.css';
import { addHomeContentOrBuildingToQuote, setQuoteData } from '../../../../actions/salesActions';
import NumberFormat from 'react-number-format';
import { PRODUCT_BUILDING, PRODUCT_HOME_CONTENT } from '../../../../constants/constants';
import { postToController } from '../../../../actions/apiActions';
import { BUILDING_COMPREHENSIVE_PRODUCT_GUID, HOME_CONTENT_COMPREHENSIVE_PRODUCT_GUID } from '../../../../constants/products';

class ReplacementValue extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            submitted: false,
            nextDisabled: true,
            minValue: 0,
            maxValue: 5000000,
            showMinMaxError: false,
        };

        this.checkSubmit = this.checkSubmit.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleGetMinMaxValues = this.handleGetMinMaxValues.bind(this);
    }

    async componentDidMount() {
        this.handleGetMinMaxValues();
    }

    async handleGetMinMaxValues() {
        let productId = BUILDING_COMPREHENSIVE_PRODUCT_GUID;
        if (this.props.sales.addProduct === PRODUCT_HOME_CONTENT) {
            productId = HOME_CONTENT_COMPREHENSIVE_PRODUCT_GUID;
        }
        await postToController(this.props.dispatch, 'GetBuildingContentMixMaxValue', JSON.stringify({ ProductId: productId, CountryId: this.props.profile.countryId })).then( (response) => {
            this.setState({ minValue: response.minimumValue, maxValue: response.maximumValue });
            this.checkSubmit(Number(this.props.sales.buildingReplacementValue));
        });
    }

    checkSubmit(value: number) {
        let isDisabled = true;
        if (isNaN(value) || value <= 0) {
            this.setState({ nextDisabled: isDisabled })
        } else if (value < this.state.minValue || value > this.state.maxValue) {
            this.setState({ showMinMaxError: isDisabled, nextDisabled: isDisabled })
        } else { this.setState({nextDisabled : false, showMinMaxError : false}) }
    }

    async handleChange(e: any) {
        let value = e.target.value.replace(this.props.profile.currencySymbol, "").replaceAll(",", "").replace(/^0+/, '');
        await this.props.dispatchAction(setQuoteData({ buildingReplacementValue: value }));
        await this.checkSubmit(Number(value));
    }

    async handleNextStep() {
        if (!this.state.nextDisabled) {
            await this.props.dispatchAction(addHomeContentOrBuildingToQuote());
        }
    }

    public render() {
        return (
            <div className="container">
                <div className="mt-4 text-center">
                    Thanks. What’s the total replacement value of your {this.props.sales.quoteType === PRODUCT_BUILDING ? "building?" : "home contents?"}
                </div>

                <div className="ssp-inputtextarea-input-element-container mt-4">
                    <div className={"form-group noma" + ((this.state.nextDisabled && this.state.replacementValue === "0") ? ' has-error' : '')}>
                        <label className={'text-left label-style form-label font-size-14px line-height-normal mb-6px ' + (this.state.replacementValue !== null ? "" : " d-none")}>Replacement value</label>
                        <div>
                            <NumberFormat
                                id="txtReplacementValueInputId"
                                name="replacementValue"
                                placeholder={this.props.profile.currencySymbol}
                                thousandSeparator={true}
                                thousandsGroupStyle="thousand"
                                prefix={this.props.profile.currencySymbol}
                                value={this.props.sales.buildingReplacementValue}
                                required={true}
                                className="ssp-inputtextarea-input-element ssp-input-editable-pen"
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                </div>
                {(this.state.showMinMaxError) &&
                    <p className="replacement-value-help-block mt-10px ml-20px mobile-ml-0px text-lg-left text-center mb-20px">The value needs to be between {this.state.minValue} and {this.state.maxValue}</p>
                }
                <div className="row mt-4">
                    <div className="col-12 justify-content-center mt-4">
                        <button type="button" className="btn btn-solid-red btnNavigate" disabled={this.state.nextDisabled} onClick={this.handleNextStep}>Next</button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        sales: state.sales,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReplacementValue);